function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 12.2724V2.45448C20 1.09889 18.8807 0 17.5 0H2.5C1.11927 0 0 1.09889 0 2.45448V17.1813C0 17.6334 0.372917 17.9995 0.832812 18C1.0224 18 1.20625 17.9366 1.35417 17.8205L5.06406 14.9063C5.21146 14.7908 5.39427 14.7274 5.58333 14.7274H17.5C18.8807 14.7274 20 13.6285 20 12.2729V12.2724ZM10.7667 10.947C10.6911 11.1525 10.526 11.3146 10.3167 11.3888C10.1151 11.4762 9.8849 11.4762 9.68333 11.3888C9.47396 11.3146 9.30885 11.1525 9.23333 10.947C9.19062 10.8488 9.16823 10.7429 9.16667 10.6361C9.16979 10.4192 9.25625 10.2122 9.40833 10.0552C9.48958 9.98307 9.58229 9.92477 9.68333 9.88336C9.88437 9.79336 10.1156 9.79336 10.3167 9.88336C10.4177 9.92477 10.5104 9.98307 10.5917 10.0552C10.7453 10.2111 10.8318 10.4192 10.8333 10.6361C10.8318 10.7429 10.8094 10.8488 10.7667 10.947ZM10.926 8.08341C10.8339 8.13761 10.7797 8.23783 10.7854 8.34368C10.7854 8.79572 10.4125 9.16184 9.95208 9.16184C9.49167 9.16184 9.11875 8.79572 9.11875 8.34368C9.10729 7.57615 9.56771 6.87713 10.2854 6.57237C10.7354 6.3888 10.949 5.88205 10.7625 5.44024C10.649 5.17127 10.4057 4.97645 10.1146 4.92122C9.68594 4.84452 9.26302 5.08281 9.11458 5.48473C8.95625 5.90915 8.4776 6.12699 8.04583 5.97205C7.61875 5.81864 7.39583 5.35792 7.54479 4.93605C8.01458 3.63314 9.47083 2.95048 10.7984 3.41121C12.1255 3.87245 12.8208 5.30218 12.3516 6.60561C12.1104 7.27496 11.5911 7.81239 10.9224 8.08341H10.9266H10.926Z"
});

function SvgIconFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon-FAQ.c5e072f7.svg";
export { ForwardRef as ReactComponent };